




















import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

@Component
export default class VideoPlayer extends Vue {
  @Prop(String) readonly source!: string;

  @Prop(String) readonly poster!: string;

  @Prop(Boolean) readonly muted!: boolean;

  @Prop(Boolean) readonly autoplay!: boolean;

  @Ref() readonly video!: HTMLVideoElement;

  paused = true;

  handlePlayState() {
    if (!this.video) {
      return;
    }

    const { paused, ended } = this.video;

    this.paused = paused || ended;

    this.$emit('paused', this.paused);

    if (!ended) {
      return;
    }

    this.video.currentTime = 0;
  }

  handlePlayToggle() {
    const { paused, ended } = this.video;

    if (paused || ended) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  handlePause() {
    const { paused, ended } = this.video;

    if (paused || ended) {
      return;
    }

    this.video.pause();
  }
}
